export enum ValueType {
    ABSOLUTE_VALUE = 'absolute-value',
    AMOUNT = 'amount',
    BOOLEAN = 'boolean',
    PROPOSE = 'propose',
    HOURS = 'hours',
    INAPPLICABLE = 'inapplicable',
    MONTH = 'month',
    MONTHS = 'months',
    PERCENTAGE = 'percentage',
    UNKNOWN = 'unknown',
}
